export default __webpack_public_path__ + "images/trolley_cabin_baggage.843e572.svg";